
export { apolloMakeClient } from "./src/apollo-make-client"